module.exports = __webpack_public_path__ + "static/media/consult.218863fb.jpg";